import { Lock, Public, Shield } from '@mui/icons-material';
import { twMerge } from '@sortlist-frontend/design-system';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import type { ReactNode } from 'react';

import { homeConfig } from '_features/home/home.config';

interface TrustItemProps {
  icon: ReactNode;
  title: string;
  description: string;
}

const TrustItem = ({ icon, title, description }: TrustItemProps) => (
  <div className="text-center">
    <div
      className={twMerge(
        'w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4',
        'bg-secondary-200 text-secondary-700',
      )}>
      {icon}
    </div>
    <h3 className="text-lg font-bold text-secondary-950 mb-2">{title}</h3>
    <p className="text-secondary-600 text-sm leading-relaxed">{description}</p>
  </div>
);

export const TrustSection = () => {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  return (
    <section className="py-20 bg-secondary-100">
      <div className="container-lg px-6">
        <header className="text-center mb-12">
          <h2 className="font-serif text-3xl font-bold text-secondary-950 mb-3 tracking-tight">
            {t('home:sections.trust.title')}
          </h2>
          <p className="text-secondary-600 max-w-lg mx-auto">{t('home:sections.trust.subtitle')}</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-4xl mx-auto">
          <TrustItem
            icon={<Shield />}
            title={t('home:sections.trust.gdpr.title')}
            description={t('home:sections.trust.gdpr.description')}
          />
          <TrustItem
            icon={<Lock />}
            title={t('home:sections.trust.encrypted.title')}
            description={t('home:sections.trust.encrypted.description')}
          />
          <TrustItem
            icon={<Public />}
            title={t('home:sections.trust.euHosted.title')}
            description={t('home:sections.trust.euHosted.description')}
          />
        </div>
      </div>
    </section>
  );
};
